<template>
  
  <div class="flex flex-column pl-2 pr-2">

      <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
        <h2 class="">PRODUKTY</h2>
        <div class="flex align-items-center">
            <router-link to="/mod-stock/products/0" class="mr-2">
              <PrimevueButton label="Pridať produkt" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
            </router-link>
            <router-link to="/mod-stock/import-products" >
              <PrimevueButton label="Import produktov" severity="success" icon="pi pi-file-excel" text raised class="uppercase"/>
            </router-link>
        </div>
      </div>
      <DataTable
          
          lazy paginator :rows="this.pagination.rows"
          @page="onPage"
          :first="this.pagination.first"
          :loading="loading"
          :totalRecords="this.pagination.totalRecords"
          dataKey="id"
          :value="this.products"
          v-model:filters="filters"
          @filter="onFilter"
          filterDisplay="row" 
          :globalFilterFields="globalFilterFields"
          stripedRows
          row-hover
          scrollable
          v-model:selection="this.selectedproduct"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="showDetail(this.selectedproduct.id)"
          tableStyle="min-width: 50rem"
          :virtualScrollerOptions="{ itemSize: 100 }"
          :scrollHeight="`${this.vh - 420}px`"
      >
        <template #header>
          <div class="flex justify-content-end">
            <IconField iconPosition="left">
              <InputIcon>
                <i class="pi pi-search mr-2"/>
              </InputIcon>
              <InputText v-model="filters['global'].value" placeholder="Vyhľadať" @keydown.enter="onFilter"/>
            </IconField>
          </div>
        </template>

        <Column header="">
          <template #body="slotProps">
              <img :src="`${slotProps.data.image}`" :alt="slotProps.data.image" class="shadow-4 border-round" width="64" />
          </template>
        </Column>

        <Column field="code" header="Kód"
                filterField="productNumber"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '6rem' }" style="min-width: 12%">
          <template #body="slotProps">
            {{ slotProps.data.code }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>
        
        <Column field="name" header="Názov"
                filterField="productName"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '8rem' }" style="min-width: 12%">
          <template #body="slotProps">
            {{ slotProps.data.name }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 10rem"/>
          </template>
        </Column>
 
        <Column field="producer" header="Výrobca"
                filterField="productProducer"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '8rem' }" style="min-width: 12%">
          <template #body="slotProps">
            {{ slotProps.data.producer }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 10rem"/>
          </template>
        </Column>

        <Column field="length" header="Dĺžka"
                filterField="productLength"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '4rem' }" style="min-width: 7%">
          <template #body="slotProps">
            {{ slotProps.data.length }}
          </template>
          <!--
          <template #filter="{ filterModel, filterCallback }">
            <InputNumber v-model="filterModel.value" :useGrouping="false" fluid @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 4rem"/>
          </template>
          -->
        </Column>

        <Column field="category.name" header="Kategória"
                filterField="categoryName"
                :showFilterMenu="false" :filterMenuStyle="{ width: '6rem' }" style="min-width: 10%"
                >
          <template #body="slotProps">
             {{ slotProps.data.category.name }}
          </template>
          
          <template #filter="{ filterModel, filterCallback }">
            <PrimevueSelect v-model="filterModel.value" @change="filterCallback()"
                      :options="this.categoryLabels" optionLabel="label" placeholder="Vyber kategóriu"
                      class="p-column-filter" style="min-width: 6rem" >
              <template #option="slotProps">
                {{slotProps.option.label}}
              </template>
            </PrimevueSelect>
          </template>
        </Column>
        


        <!--
        <Column header="" style="min-width: 5%">
          <template #body="slotProps">
            <div
              class="color-box"
              :style="{ backgroundColor: slotProps.data.color.colorHash }"
            ></div>
          </template>
        </Column>
        -->

        <Column header="">
          <template #body="slotProps">

            <PrimevueButton type="button" v-tooltip.top="{ value: 'Vymazanie produktu' }" icon="pi pi-trash" @click="confirmDelete(slotProps.data.id)" text severity="danger" size="small"/>
            <!--
            <a  @click="confirmDelete(slotProps.data.id)" target="_blank">
              <PrimevueButton label="Odstrániť" text raised icon="pi pi-trash" severity="danger"/>
             </a>
             -->
          </template>
        </Column>
      </DataTable>
  </div>
  <ConfirmDialog></ConfirmDialog>

</template>

<script lang="ts">

import IconField from 'primevue/iconfield';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import PrimevueSelect from "primevue/dropdown";
import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
//import Utils from '@/components/utils';
//import {emiter} from '../main';

export default {
  components: {
    DataTable,
    Column,
    IconField,
    PrimevueSelect,
    InputIcon,
    PrimevueButton

  },
  name: "ProductList",
  data() {
    return {
      store,
      vh: 0,
      selectedproduct: null,
      products: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        productNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        productName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        productProducer: {value: null, matchMode: FilterMatchMode.CONTAINS},
        categoryName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        //productLength: {value: null, matchMode: FilterMatchMode.EQUALS},
      },
      filterFields: [  {field: 'Code',value: ""},
                       {field: 'CategoryId__Name',value: ""},
                       {field: 'Name',value: ""},
                       {field: 'Producer',value: ""},                       
                       //{field: 'Length',value: ""}
                    ],
      globalFilterFields: ['Code', 'Name', 'Producer','CategoryId__Name'],
      categories: [],
      //selectedCategory: 0,
      categoryLabels: [],
      loading: true,
      //lazyParams: [],
      pagination: {
        first: 0,
        rows: 15,
        totalRecords: 0, // Total number of records for pagination
        filters: {},
      },
    }
  },
  beforeMount() {
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
      
       
      this.initFilters()

      //if (store.user.admin) {
      //  this.globalFilterFields = ['productCode', 'ModifiedUser__LastName','CustomerId__Company', 'CustomerLastName', 'CurrentState__Name']
      //}

      
      fetch(store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + responseData.message,
                      position: "top"
                    })           
            } else {
              //console.log(responseData);
              this.categories = responseData.data
              this.categories.forEach((category) => {
                let categ = {label: category.name}
                this.categoryLabels.push(categ)
              });
              this.loading = false
            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + error,
                      position: "top"
                    })           
      });
      
      this.loadComponent()
    }
  },
  
  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {
    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },

 
    showDetail(productId:number) {
      router.push('/mod-stock/products/' + String(productId))
    },
    confirmDelete(productId:number) {
      this.$confirm.require({
          message: 'Naozaj chcete vymazať produkt?',
          header: 'Vymazanie produktu',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.deleteproduct(productId)
          },

      });
    },
    deleteproduct(productId:number){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ objednávku?")){
        Security.requireToken();
        fetch(store.Api_url + "/v1/product/" + String(productId), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Produkt sa nepodarilo odstrániť: " + responseData.message,
                    position: "top"
                  })           
              } else {

                //this.products = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Produkt bol odstránený",
                  position: "bottom"
                })
                this.initFilters()
                this.loadComponent()
              }
            })
            .catch((error) => {
              alert('Chyba pri odstránení produktu: ' + error)
            })
      //}
    },

    onPage(event) {
        this.pagination.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination);
    },

    loadComponent(){

      this.pagination.first = 0
      this.pagination.totalRecords = 0

      this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination)

    },
    initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.table = "product"
        this.pagination.filters.globalFilterFields = this.globalFilterFields;

    },
    onFilter(event) {
        if(event.filters){
          console.log("Event:", event);
           this.pagination.filters.filterFields = [ {field: 'Code',value: event.filters.productNumber.value ? event.filters.productNumber.value : ""},
                                                    {field: 'Name',value: event.filters.productName.value ? event.filters.productName.value: ""},
                                                    {field: 'CategoryId__Name',value: event.filters.categoryName.value ? event.filters.categoryName.value.label: ""},
                                                    {field: 'Producer',value: event.filters.productProducer.value ? event.filters.productProducer.value: ""},
                                                    //{field: 'Length',value: event.filters.productLength.value ? event.filters.productLength.value : ""}
                                                  ];
           this.pagination.filters.global = event.filters.global.value                                        
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
          //console.log("Filters:", this.pagination.filters);
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        //console.log("Filters:", this.pagination.filters);
        this.loadLazyData(this.store.basicUrlFilterProducts,this.pagination);
    },
    loadLazyData(route,params) {
      this.loading = true;

      let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

      fetch(`${store.Api_url}${route}${queryParams}`, Security.requestOptions("POST",params.filters))
          .then(response => response.json())
          .then(responseData => {
            if (responseData.error) {
              //console.error("error:", responseData.message);
              //this.$emit('error', responseData.message);
              notie.alert({
                    type: 'error',
                    text: "Zoznam produktov sa nepodarilo načítať " + responseData.message,
                    position: "top"
                  })           
            } else {
              if(responseData.data){
                  this.products = responseData.data;

                }else{
                    notie.alert({
                    type: 'info',
                    text: "Zoznam produktov je prázdny",
                    position: "top"
                  })
                  this.products = []
                }
              this.pagination.totalRecords = responseData.totalRecords;
              this.loading = false;
            }
          })
          .catch(error => {
            //alert('Error fetching data: ' + error);
            notie.alert({
                    type: 'error',
                    text: "Chyba pri načítaní produktov: "+error,
                    position: "top"
                  })
            this.loading = false;
          });
    }
  }

}
</script>

<style>


</style>